import { createSelector } from 'reselect'

export const locationsByRetailerIdSelector = (state) =>
  (state.locations && state.locations.retailers) || {}

export const selectLocationsByRetailerId = createSelector(
  [locationsByRetailerIdSelector],
  (locationsByRetailerId) => ({
    locationsByRetailerId,
  }),
)
